// crypto-manager.js
import CryptoAES from './cryptoAES';

class CryptoManager {
    constructor() {
        this.instances = new Map();  // 存储不同配置的实例
    }

    getInstance(prefix = "qsx", domain = "qushixi.cn") {
        const key = `${prefix}-${domain}`;
        if (!this.instances.has(key)) {
            this.instances.set(key, new CryptoAES(prefix, domain));
        }
        return this.instances.get(key);
    }
}

export default new CryptoManager();